<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Dashboard" />
      <h2>Dashboard</h2>
      <flash-messages />
    </template>

    <template v-slot:breadcrumbs>
      <BreadCrumbs activeItem="Home"/>
    </template>

    <template v-slot:default>
      <div class="row">
        <div class="col-12 col-lg-4">
          <card icon="fas fa-user" :title="`Who's Online (${online.length})`">
            <DataTable :value="online"
            v-if="online.length > 0"
            breakpoint="992px"
            class="p-datatable-sm" 
            responsiveLayout="stack" 
            stripedRows>
              <Column field="id" header="ID"></Column>
              <Column field="company_name" header="MTD">
                <template #body="slotProps">
                  <template v-if="slotProps.data.company_name">
                    <inertia-link :href="route('mtd.view', slotProps.data.id)">
                    {{ slotProps.data.company_name }}
                  </inertia-link>
                  </template>
                  <template v-else-if="slotProps.data.mtd_company_name">
                    Tool User under 
                    <inertia-link :href="route('mtd.view', slotProps.data.id)">{{ slotProps.data.mtd_company_name }}
                  </inertia-link>
                  </template>
                  <template v-else>
                    Admin
                  </template>
                </template>
              </Column>
              <Column field="name" header="Name"></Column>
              <Column field="last_activity" header="Last Active">
                <template #body="slotProps">
                  {{ moment(slotProps.data.last_activity).format('M/D/YY h:mm A') }}            
                </template>
              </Column>
        <Column field="cart_value" header="Current Cart" :sortable="true">
          <template #body="slotProps">
            <span v-if="slotProps.data.cart_value">
              {{ moment.utc(slotProps.data.cart_date).format('M/D/YY') }} {{ formatDollars(slotProps.data.cart_value) }}
            </span>
            <span v-else>
              No Cart
            </span>
          </template>
        </Column>
        <Column field="cart_value" header="">
          <template #body="slotProps">
            <span v-if="slotProps.data.cart_value">
              <a href="javascript:;;" title="View Cart" @click="openUserCartViewer(slotProps.data.id)"><i class="fa fa-eye"></i></a>
            </span>
          </template>
        </Column>
            </DataTable>
          </card>
        </div>
        <div class="col-12 col-lg-8 mt-3 mt-lg-0">
          <div class="row mb-3">
            <div class="col-12 col-lg-6 mb-3 mb-lg-0">
              <card title="Orders by Month">
                <Chart type="bar" :data="stats.salesMonth" />
              </card>
            </div>
            <div class="col-12 col-lg-6">
              <card title="Orders by Day">
                <Chart type="bar" :data="stats.salesDay" />
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 mb-3 mb-lg-0">
              <card title="Sales by Month">
                <Chart type="bar" :data="stats.salesVolumeMonth" />
              </card>
            </div>
            <div class="col-12 col-lg-6">
              <card title="Sales by Day">
                <Chart type="bar" :data="stats.salesVolumeDay" />
              </card>
            </div>
          </div>
          <div class="row my-3" v-if="stats.paymentsMonth">
            <div class="col-12 col-lg-6 mb-3 mb-lg-0">
              <card title="Payments by Month">
                <Chart type="bar" :data="stats.paymentsMonth" />
              </card>
            </div>
            <div class="col-12 col-lg-6">
              <card title="Payments by Day">
                <Chart type="bar" :data="stats.paymentsDay" />
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>
  </layout>
  <teleport to="body">
    <UserCartViewerModal :url="cartViewerLink" :mtdId="mtdId" />
  </teleport>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import FlashMessages from '@/Shared/FlashMessages'
  import BreadCrumbs from '@/Shared/BreadCrumbs'
  import UserCartViewerModal from '@/Components/Modals/UserCartViewerModal'

  import moment from 'moment'
  import Chart from 'primevue/chart'

  export default {
    components: {
      UserCartViewerModal,
      Layout,
      FlashMessages,
      BreadCrumbs,
      Chart
    },
    props: {
      online: Array,
      user: Object,
      stats: Object,
    },
    data() {
      return {
        cartViewerLink: null,
        mtdId: null
      }
    },
    created: function () {
      this.moment = moment;
    },
    methods: {
      openUserCartViewer(id) {
        this.cartViewerLink = this.route('mtd.cart.viewer', id)
        this.mtdId = id;
        $('#userCartViewerModal').modal('show');
      }
    }
  }
</script>
